/**
 * Utility functions for generating unique identifiers
 */

/**
 * Generate a UUID v4
 * Uses crypto.randomUUID if available, falls back to manual implementation
 */
export const generateUUID = (): string => {
  // Modern browsers support crypto.randomUUID
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  
  // Fallback for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Generate a timestamp-based ID with random suffix
 * Format: timestamp_randomString
 * Example: "1703123456789_a3b2c1"
 */
export const generateTimestampId = (): string => {
  const timestamp = Date.now();
  const randomSuffix = Math.random().toString(36).substring(2, 8);
  return `${timestamp}_${randomSuffix}`;
};

/**
 * Generate a selection group ID for multi-page selections
 * Uses UUID for maximum uniqueness
 */
export const generateSelectionGroupId = (): string => {
  return `group_${generateUUID()}`;
};

/**
 * Generate a short random ID (6 characters)
 * Useful for user-facing IDs
 */
export const generateShortId = (): string => {
  return Math.random().toString(36).substring(2, 8);
};